import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import config from '@/pathConfig';
var Base64 = require('js-base64').Base64;
import { Empty } from 'ant-design-vue';
import { acceptance, queryRepairPerson, repairDispatch, orderTaking, saveCompleteSupplies, repairAll, evaluate, batchUploadFile, queryOuterPersonList } from '@/api/repairs/repairsApi.js';
// import { batchUploadFile } from '@/api/commonApi.js';
export default {
  data: function data() {
    return {
      sliderbarShow: false,
      //控制流转记录弹出与显示
      sliderbar: false,
      //控制流转记录弹出与显示
      repairList: [],
      //报修详细信息
      completeList: [],
      //完工详细信息
      recordList: [],
      //流转记录
      evaluateList: [],
      //评价详情记录
      //报修评价填写表单
      evaluationForm: {
        fillId: '',
        //报修单id
        isRepair: 0,
        //是否修好 0是 1否
        speed: 0,
        //响应速度
        attitude: 0,
        //服务态度
        technicallevel: 0,
        //技术水平
        quality: 0,
        //维修质量
        evaluate: 0,
        //整体质量
        fileList: [],
        //附件存储
        faultImgList: [],
        //上传后图片返回存入的数组
        remark: '' //备注信息
      },
      //报修评价填写表单校验
      evaluationFormRules: {
        isRepair: [{
          required: true,
          message: '请选择状态',
          trigger: ['change', 'blur']
        }],
        // speed: [{ required: true, message: '请选择评分', trigger: ['change', 'blur'] }],
        // attitude: [{ required: true, message: '请选择评分', trigger: ['change', 'blur'] }],
        // technicallevel: [
        //     { required: true, message: '请选择评分', trigger: ['change', 'blur'] }
        // ],
        // quality: [{ required: true, message: '请选择评分', trigger: ['change', 'blur'] }],
        evaluate: [{
          required: true,
          message: '请选择评分',
          trigger: ['change', 'blur']
        }]
      },
      feedBackWidth: '60%',
      //反馈报修单宽度
      //反馈报修单填写对象
      feedbackForm: {
        fillId: '',
        //报修id
        status: 0,
        //反馈报修单状态 0维修完成 1不能维修需转派
        repairDate: '',
        //维修时间
        partsList: {
          //零件清单数组
          matterList: [
            // {
            //     partName: '', //零件名称
            //     partModel: '', //零件型号
            //     partUnit: '', //单位
            //     partNumber: '', //数量
            //     partPrice: '', //单价
            //     totalPrice: '', //总价
            //     partFactory: '', //厂家
            //     damageReason: '' //损坏原因
            // }
          ]
        },
        feedbackRemark: '',
        //备注信息
        fileList: [],
        //附件存储
        faultImgList: [] //上传后图片返回存入的数组
      },
      //反馈报修单校验
      feedbackFormRules: {
        status: [{
          required: true,
          message: '请选择状态',
          trigger: ['change', 'blur']
        }],
        repairDate: [{
          required: true,
          message: '请选择维修时间',
          trigger: ['change', 'blur']
        }]
      },
      //受理报修单填写对象
      acceptanceForm: {
        id: '',
        //报修单的id
        status: 0,
        //状态确认 0确认 1驳回
        category: 0,
        //维修类别 0现场维修 1厂家维修
        maintainuser: undefined,
        //人员名称id
        remarksContent: undefined,
        //现场维修的备注信息
        remarksContentOther: undefined,
        //厂家维修的备注信息
        acceptanceFormList: [],
        //附件图片
        faultImgList: [] //上传后图片返回存入的数组
      },
      //受理报修单校验
      acceptanceFormRules: {
        status: [{
          required: true,
          message: '请选择状态',
          trigger: ['change', 'blur']
        }],
        category: [{
          required: true,
          message: '请选择维修类别',
          trigger: ['change', 'blur']
        }],
        maintainuser: [{
          required: true,
          message: '请选择维修人员',
          trigger: ['change', 'blur']
        }]
      },
      //派单人员填写对象
      sendOrderForm: {
        id: '',
        //报修id
        type: 0,
        servicePerson: undefined,
        //维修人员
        remarksContent: undefined,
        //备注信息
        fileList: [],
        //附件存储
        status: 0,
        //派单
        faultImgList: [] //上传后图片返回存入的数组
      },
      //派单人员填写校验
      sendOrderFormRules: {
        servicePerson: [{
          required: true,
          message: '请选择维修人员',
          trigger: ['change', 'blur']
        }]
      },
      //接单人员填写对象
      orderForm: {
        id: '',
        //报修id
        orderPerson: '',
        //维修人
        status: 0,
        //是否接单 0是 1否
        orderRemark: undefined,
        //接单备注信息
        fileList: [],
        //附件存储
        faultImgList: [] //上传后图片返回存入的数组
      },
      //接单人员填写校验
      orderFormRules: {
        status: [{
          required: true,
          message: '请选择状态',
          trigger: ['change', 'blur']
        }]
      },
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      formObject: {
        detail: {
          matterList: [{
            partsNmae: '',
            //零件名称
            partsModel: '',
            //零件型号
            partsUnit: '',
            //单位
            partsNumber: '',
            //数量
            partsPrice: '',
            //单价
            partsTotalPrices: '',
            //总价
            partsManufacturer: '',
            //厂家
            partsDamageReason: '' //损坏原因
          }]
        }
      },
      orderShow: false,
      //接单弹窗显示
      sendOrdersShow: false,
      //派单弹窗显示
      acceptShow: false,
      //受理弹窗显示
      spanLeft: 24,
      spanRight: 6,
      type: '',
      headers: {
        Authorization: sessionStorage.getItem('token')
      },
      config: config,
      speedValue: 0,
      evaluation: false,
      //评价弹窗显示
      title: undefined,
      mode: undefined,
      form: {
        id: undefined,
        repairDetail: {},
        fixDetail: {
          fixPerson: undefined,
          status: undefined,
          fixTime: undefined
        },
        evaluation: {}
      },
      backTo: undefined,
      cardBodyStyle: {
        height: 'calc(100vh - 18rem + 19px)',
        'overflow-y': 'auto'
      },
      value: 5,
      feedbackStatus: false,
      imageUrl: '',
      previewShow: false,
      repairsId: '',
      //存储上个页面传递下来的报修id值
      repairPersonList: [],
      //维修人存储数组
      userInfo: this.$hdk.userInfo.get(),
      outerPersonList: []
    };
  },
  methods: {
    //流转记录点击弹出
    clickChange: function clickChange() {
      this.sliderbar = !this.sliderbar;
      this.sliderbarShow = true;
    },
    //填写价格时计算总价
    partPriceChange: function partPriceChange(index) {
      this.feedbackForm.partsList.matterList[index].totalPrice = this.feedbackForm.partsList.matterList[index].partPrice * this.feedbackForm.partsList.matterList[index].partNumber;
    },
    //填写数量时计算总价
    partNumberChange: function partNumberChange(index) {
      this.feedbackForm.partsList.matterList[index].totalPrice = this.feedbackForm.partsList.matterList[index].partPrice * this.feedbackForm.partsList.matterList[index].partNumber;
    },
    /**
     * 选择状态修改弹窗宽度
     */
    feedclick: function feedclick() {
      this.feedBackWidth = '60%';
    },
    /**
     * 获取维修人员信息
     */
    getQueryRepairPerson: function getQueryRepairPerson() {
      var _this = this;
      queryRepairPerson().then(function (res) {
        _this.repairPersonList = res.data.data;
      });
    },
    /**
     * 校外人员集合
     */
    getSchoolRepairPerson: function getSchoolRepairPerson() {
      var _this2 = this;
      queryOuterPersonList({
        companyName: '',
        perName: ''
      }).then(function (res) {
        _this2.outerPersonList = res.data.data;
      });
    },
    /**
     * 维修评价文件上传存值
     */
    evaluationFormActionUpload: function evaluationFormActionUpload(data) {
      var $message = this.$message,
        evaluationForm = this.evaluationForm;
      if (evaluationForm.fileList.length > 5) {
        $message.error('文件最多同时上传5个');
        return;
      } else {
        // 用于上传后回显及往文件对象存值
        this.evaluationForm.fileList.push({
          fileid: data.file.uid,
          filename: data.file.name,
          fileSize: data.file.size,
          file: data.file,
          uid: data.file.uid,
          name: data.file.name,
          status: 'done',
          type: 0
        });
      }
    },
    /**
     * 维修文件删除
     */
    evaluationFormDelFile: function evaluationFormDelFile(data) {
      if (1 === this.evaluationForm.fileList.length) {
        this.evaluationForm.fileList = [];
        // this.formObject.attach = [];
      } else {
        var evens = _.remove(this.evaluationForm.fileList, function (n) {
          if (n.fileid != data.fileid) {
            return n;
          }
        });
        this.evaluationForm.fileList = evens;
        // this.formObject.attach = evens;
      }
    },
    /**
     * 点击维修评价按钮弹出弹窗
     */
    evaluationShow: function evaluationShow() {
      this.evaluation = true;
    },
    /**
     * 维修评价图片上传并提交
     */
    evaluationSubmit: function evaluationSubmit() {
      var _this3 = this;
      this.evaluationForm.fillId = Number(this.repairsId);
      if (this.evaluationForm.fileList.length > 0) {
        var newFileObj = _.map(this.evaluationForm.fileList, function (item) {
          if (item.type === 0) {
            return item;
          } else {
            return;
          }
        });
        // 去除为空的
        newFileObj = _.compact(newFileObj);
        // 判断处理后的附件是否为空,为空表示没有新上传附件
        if (newFileObj.length > 0) {
          batchUploadFile(newFileObj).then(function (res) {
            _.map(res.data.data, function (item) {
              _this3.evaluationForm.faultImgList.push({
                faultImgName: item.originalName,
                faultImgPath: item.filepath,
                originalname: item.originalName
              });
            });
            _this3.evaluationUnload();
          });
        } else {
          this.evaluationUnload();
        }
      } else {
        this.evaluationUnload();
      }
    },
    /**
     * 维修评价提交
     */
    evaluationUnload: function evaluationUnload() {
      var _this4 = this;
      this.$refs.evaluationForm.validate(function (valid) {
        if (valid) {
          evaluate(_this4.evaluationForm).then(function (res) {
            if (res.data.code == 200) {
              _this4.$message.success('提交成功', 10);
              _this4.evaluation = false;
              _this4.backPage();
            } else {
              _this4.$message.error('提交失败', 10);
            }
          });
        } else {
          return false;
        }
      });
    },
    evaluationCancel: function evaluationCancel() {
      this.$refs.evaluationForm.resetFields();
      this.evaluation = false;
    },
    /**
     * 受理文件上传存值
     */
    actionUpload: function actionUpload(data) {
      var $message = this.$message,
        acceptanceForm = this.acceptanceForm;
      if (acceptanceForm.acceptanceFormList.length > 5) {
        $message.error('文件最多同时上传5个');
        return;
      } else {
        // 用于上传后回显及往文件对象存值
        this.acceptanceForm.acceptanceFormList.push({
          fileid: data.file.uid,
          filename: data.file.name,
          fileSize: data.file.size,
          file: data.file,
          uid: data.file.uid,
          name: data.file.name,
          status: 'done',
          type: 0
        });
      }
    },
    /**
     * 文件大小
     */
    beforeUpload: function beforeUpload(file) {
      var $message = this.$message;
      var isLt1M = file.size / 1024 / 1024 < 500;
      if (!isLt1M) {
        $message.error('最大只能上传500MB');
      }
      return isLt1M;
    },
    /**
     * 接单文件上传存值
     */
    orderActionUpload: function orderActionUpload(data) {
      var $message = this.$message,
        orderForm = this.orderForm;
      if (orderForm.fileList.length > 5) {
        $message.error('文件最多同时上传5个');
        return;
      } else {
        // 用于上传后回显及往文件对象存值
        this.orderForm.fileList.push({
          fileid: data.file.uid,
          filename: data.file.name,
          fileSize: data.file.size,
          file: data.file,
          uid: data.file.uid,
          name: data.file.name,
          status: 'done',
          type: 0
        });
      }
    },
    /**
     * 接单文件删除
     */
    orderDelFile: function orderDelFile(data) {
      if (1 === this.orderForm.fileList.length) {
        this.orderForm.fileList = [];
      } else {
        var evens = _.remove(this.orderForm.fileList, function (n) {
          if (n.fileid != data.fileid) {
            return n;
          }
        });
        this.orderForm.fileList = evens;
      }
    },
    //反馈文件上传存值
    feedbackActionUpload: function feedbackActionUpload(data) {
      var $message = this.$message,
        feedbackForm = this.feedbackForm;
      if (feedbackForm.fileList.length > 5) {
        $message.error('文件最多同时上传5个');
        return;
      } else {
        // 用于上传后回显及往文件对象存值
        this.feedbackForm.fileList.push({
          fileid: data.file.uid,
          filename: data.file.name,
          fileSize: data.file.size,
          file: data.file,
          uid: data.file.uid,
          name: data.file.name,
          status: 'done',
          type: 0
        });
      }
    },
    //反馈文件删除
    feedbackDelFile: function feedbackDelFile(data) {
      if (1 === this.feedbackForm.fileList.length) {
        this.feedbackForm.fileList = [];
      } else {
        var evens = _.remove(this.feedbackForm.fileList, function (n) {
          if (n.fileid != data.fileid) {
            return n;
          }
        });
        this.feedbackForm.fileList = evens;
      }
    },
    /**
     * 派单文件上传存值
     */
    sendOrderActionUpload: function sendOrderActionUpload(data) {
      var $message = this.$message,
        sendOrderForm = this.sendOrderForm;
      if (sendOrderForm.fileList.length > 5) {
        $message.error('文件最多同时上传5个');
        return;
      } else {
        // 用于上传后回显及往文件对象存值
        this.sendOrderForm.fileList.push({
          fileid: data.file.uid,
          filename: data.file.name,
          fileSize: data.file.size,
          file: data.file,
          uid: data.file.uid,
          name: data.file.name,
          status: 'done',
          type: 0
        });
      }
    },
    /**
     * 派单文件删除
     */
    sendOrderDelFile: function sendOrderDelFile(data) {
      var sendOrderForm = this.sendOrderForm;
      if (1 === sendOrderForm.fileList.length) {
        this.sendOrderForm.fileList = [];
      } else {
        var evens = _.remove(this.sendOrderForm.fileList, function (n) {
          if (n.fileid != data.fileid) {
            return n;
          }
        });
        this.sendOrderForm.fileList = evens;
      }
    },
    /**
     * 受理文件删除
     */
    delFile: function delFile(data) {
      var acceptanceForm = this.acceptanceForm;
      if (1 === acceptanceForm.acceptanceFormList.length) {
        this.acceptanceForm.acceptanceFormList = [];
      } else {
        var evens = _.remove(this.acceptanceForm.acceptanceFormList, function (n) {
          if (n.fileid != data.fileid) {
            return n;
          }
        });
        this.acceptanceForm.acceptanceFormList = evens;
      }
    },
    delMatter: function delMatter(item) {
      var index = this.feedbackForm.partsList.matterList.indexOf(item);
      if (index !== -1) {
        this.feedbackForm.partsList.matterList.splice(index, 1);
      }
    },
    addMatter: function addMatter() {
      this.feedbackForm.partsList.matterList.push({
        partName: '',
        //零件名称
        partModel: '',
        //零件型号
        partUnit: '',
        //单位
        partNumber: '',
        //数量
        partPrice: '',
        //单价
        totalPrice: '',
        //总价
        partFactory: '',
        //厂家
        damageReason: '' //损坏原因
      });
    },
    imageClick: function imageClick(item) {
      // this.previewShow = true;
      // this.imageUrl =
      //     'http://43.136.181.215:4999/server/index.php?s=/api/attachment/visitFile&sign=066d4c78facab25042592fe533f55e34';

      this.imageUrl = this.config.baseUrl + 'repairPath' + item.faultImgPath;
      window.open(config.filePreview + '?url=' + encodeURIComponent(Base64.encode(this.imageUrl)), '_blank');
    },
    /**
     * 点击接单按钮弹出弹出
     */
    orderClick: function orderClick() {
      this.orderShow = true;
    },
    order: function order() {
      var _this5 = this;
      this.$refs.orderForm.validate(function (valid) {
        if (valid) {
          orderTaking(_this5.orderForm).then(function (res) {
            if (res.data.code == 200) {
              _this5.$message.success('提交成功', 10);
              _this5.orderShow = false;
              _this5.backPage();
            } else {
              _this5.$message.error('提交失败', 10);
            }
          });
        } else {
          return false;
        }
      });
    },
    orderSubmit: function orderSubmit() {
      var _this6 = this;
      this.orderForm.id = this.repairsId;
      if (this.orderForm.fileList.length > 0) {
        var newFileObj = _.map(this.orderForm.fileList, function (item) {
          if (item.type === 0) {
            return item;
          } else {
            return;
          }
        });
        // 去除为空的
        newFileObj = _.compact(newFileObj);
        // 判断处理后的附件是否为空,为空表示没有新上传附件
        if (newFileObj.length > 0) {
          batchUploadFile(newFileObj).then(function (res) {
            _.map(res.data.data, function (item) {
              _this6.orderForm.faultImgList.push({
                faultImgName: item.originalName,
                faultImgPath: item.filepath,
                originalname: item.originalName
              });
            });
            _this6.order();
          });
        } else {
          this.order();
        }
      } else {
        this.order();
      }
    },
    orderCancel: function orderCancel() {
      this.orderShow = false;
    },
    /**
     * 点击派单按钮弹出弹窗
     */
    sendOrdersClick: function sendOrdersClick() {
      this.sendOrdersShow = true;
    },
    sendOder: function sendOder() {
      var _this7 = this;
      this.$refs.sendOrderForm.validate(function (valid) {
        if (valid) {
          repairDispatch(_this7.sendOrderForm).then(function (res) {
            if (res.data.code == 200) {
              _this7.$message.success('提交成功', 10);
              _this7.sendOrdersShow = false;
              _this7.backPage();
            } else {
              _this7.$message.error('提交失败', 10);
            }
          });
        } else {
          return false;
        }
      });
    },
    sendOrdersSubmit: function sendOrdersSubmit() {
      var _this8 = this;
      this.sendOrderForm.id = this.repairsId;
      if (this.sendOrderForm.fileList.length > 0) {
        var newFileObj = _.map(this.sendOrderForm.fileList, function (item) {
          if (item.type === 0) {
            return item;
          } else {
            return;
          }
        });
        // 去除为空的
        newFileObj = _.compact(newFileObj);
        // 判断处理后的附件是否为空,为空表示没有新上传附件
        if (newFileObj.length > 0) {
          batchUploadFile(newFileObj).then(function (res) {
            _.map(res.data.data, function (item) {
              _this8.sendOrderForm.faultImgList.push({
                faultImgName: item.originalName,
                faultImgPath: item.filepath,
                originalname: item.originalName
              });
            });
            _this8.sendOder();
          });
        } else {
          this.sendOder();
        }
      } else {
        this.sendOder();
      }
    },
    sendOrdersCancel: function sendOrdersCancel() {
      this.$refs.sendOrderForm.resetFields();
      this.sendOrdersShow = false;
    },
    /**
     * 点击受理按钮弹出弹窗
     */
    acceptClick: function acceptClick() {
      this.acceptShow = true;
    },
    accept: function accept() {
      var _this9 = this;
      this.$refs.acceptanceForm.validate(function (valid) {
        if (valid) {
          acceptance(_this9.acceptanceForm).then(function (res) {
            if (res.data.code == 200) {
              _this9.$message.success('提交成功', 10);
              _this9.acceptShow = false;
              _this9.backPage();
            } else {
              _this9.$message.error('提交失败', 10);
            }
          });
        } else {
          return false;
        }
      });
    },
    acceptSubmit: function acceptSubmit() {
      var _this0 = this;
      this.acceptanceForm.id = Number(this.repairsId);
      if (this.acceptanceForm.acceptanceFormList.length > 0) {
        var newFileObj = _.map(this.acceptanceForm.acceptanceFormList, function (item) {
          if (item.type === 0) {
            return item;
          } else {
            return;
          }
        });
        // 去除为空的
        newFileObj = _.compact(newFileObj);

        // this.formObject.attach = _.remove(fileObj, n => {
        //     if (n.type === 1) {
        //         return n;
        //     }
        // });
        // 判断处理后的附件是否为空,为空表示没有新上传附件
        if (newFileObj.length > 0) {
          batchUploadFile(newFileObj).then(function (res) {
            _.map(res.data.data, function (item) {
              _this0.acceptanceForm.faultImgList.push({
                faultImgName: item.originalName,
                faultImgPath: item.filepath,
                originalname: item.originalName
              });
            });
            _this0.accept();
          });
        } else {
          this.accept();
        }
      } else {
        this.accept();
      }
    },
    /**
     * 受理报修单点击取消
     */
    acceptCancel: function acceptCancel() {
      this.$refs.acceptanceForm.resetFields();
      this.acceptShow = false;
    },
    /**
     * 图片预览关闭
     */
    handleCancel: function handleCancel() {
      this.previewShow = false;
    },
    handlePreview: function handlePreview(file) {
      return;
      if (file.response.code == 200) {
        var url = file.response.data.url;
        var fileUrl = config.baseUrl + url;
        // this.imageUrl = fileUrl;
        window.open(config.filePreview + '?url=' + encodeURIComponent(Base64.encode(fileUrl)), '_blank');

        // this.previewShow = true;
        // this.config.filePreview + '?url=' + encodeURIComponent(Base64.encode(fileUrl));
        // console.log(this.config.filePreview,"config.filePreview",url,fileUrl)
      }
    },
    /**
     *返回上一层
     */
    backPage: function backPage() {
      if (this.backTo == 'repair') {
        this.$router.push({
          path: '/dashboard/repair'
        });
      } else if (this.backTo == 'homepage') {
        this.$router.push({
          path: '/dashboard/homepage'
        });
      } else if (this.backTo == 'system') {
        this.$router.push({
          path: '/dashboard/systemnotifi'
        });
      } else {
        this.$router.push({
          path: '/reimburseRepairs/repairs/' + this.backTo
        });
      }
    },
    /**
     * 反馈提交
     */
    feedback: function feedback() {
      var _this1 = this;
      this.$refs.feedbackForm.validate(function (valid) {
        if (valid) {
          saveCompleteSupplies(_this1.feedbackForm).then(function (res) {
            if (res.data.code == 200) {
              _this1.$message.success('提交成功', 10);
              _this1.feedbackStatus = false;
              _this1.backPage();
            } else {
              _this1.$message.error('提交失败', 10);
            }
          });
        } else {
          return false;
        }
      });
    },
    feedbackSubmit: function feedbackSubmit() {
      var _this10 = this;
      this.feedbackForm.fillId = Number(this.repairsId);
      if (this.feedbackForm.fileList.length > 0) {
        var newFileObj = _.map(this.feedbackForm.fileList, function (item) {
          if (item.type === 0) {
            return item;
          } else {
            return;
          }
        });
        // 去除为空的
        newFileObj = _.compact(newFileObj);
        // 判断处理后的附件是否为空,为空表示没有新上传附件
        if (newFileObj.length > 0) {
          batchUploadFile(newFileObj).then(function (res) {
            _.map(res.data.data, function (item) {
              _this10.feedbackForm.faultImgList.push({
                faultImgName: item.originalName,
                faultImgPath: item.filepath,
                originalname: item.originalName
              });
            });
            _this10.feedback();
          });
        } else {
          this.feedback();
        }
      } else {
        this.feedback();
      }
      // this.feedbackStatus = false;
    },
    /**
     * 反馈报修单点击取消
     */
    feedbackCancel: function feedbackCancel() {
      this.feedbackStatus = false;
    },
    /**
     * 反馈点击显示
     */
    feedbackClick: function feedbackClick() {
      this.feedbackStatus = true;
    },
    /**
     * 转派点击显示
     */
    acceptFeedbackClick: function acceptFeedbackClick() {
      this.sendOrdersShow = true;
      this.sendOrderForm.status = 1;
    },
    /**
     * 查询报修详细信息
     */
    getRepairAll: function getRepairAll() {
      var _this11 = this;
      repairAll(this.repairsId).then(function (res) {
        if (res.data.code == 200) {
          _this11.repairList = res.data.repair; //报修详细信息
          _this11.completeList = res.data.complete; //完工详细信息
          _this11.recordList = res.data.record; //流转记录
          _this11.evaluateList = res.data.evaluate; //评价详情记录
        }
      });
    },
    handleChangeCategory: function handleChangeCategory(e) {
      if (e.target.value === 0 && this.acceptanceForm.maintainuser) {
        this.acceptanceForm.maintainuser = undefined;
      } else {
        this.acceptanceForm.maintainuser = undefined;
      }
    },
    handleChangeSendOrder: function handleChangeSendOrder(e) {
      if (e.target.value === 0 && this.sendOrderForm.servicePerson) {
        this.sendOrderForm.servicePerson = undefined;
      } else {
        this.sendOrderForm.servicePerson = undefined;
      }
    }
  },
  mounted: function mounted() {
    var that = this;
    var query = this.$route.query;
    var timestamp = Date.parse(new Date());
    var date = new Date(timestamp);
    //获取年
    var Y = date.getFullYear();
    //获取月
    var M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    //获取当日
    var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    this.feedbackForm.repairDate = Y + '-' + M + '-' + D;
    that.mode = query.mode;
    if (query.id) {
      this.repairsId = query.id;
    }
    this.type = query.type;
    if (this.type == 1) {
      this.spanLeft = 24;
      this.spanRight = 0;
    }
    if (that.mode != 'view') {
      this.sliderbarShow = true;
      this.sliderbar = true;
    } else {
      this.sliderbarShow = false;
      this.sliderbar = false;
    }
    that.backTo = query.backTo;
    if (that.mode === 'view') {
      that.title = '查看';
    } else if (that.mode === 'evaluation') {
      that.title = '评价';
    } else if (that.mode === 'accept') {
      that.title = '受理';
    } else if (that.mode === 'order') {
      that.title = '接单';
    } else if (that.mode === 'feedback') {
      that.title = '反馈';
    } else if (that.mode === 'dispose') {
      that.title = '派单';
    }
    this.getQueryRepairPerson();
    this.getRepairAll();
    this.getSchoolRepairPerson();
  },
  created: function created() {
    var userInfo = this.userInfo;
    this.orderForm.orderPerson = userInfo.userName;
  }
};